import { Typography } from '@mui/material'
import { useEffect } from 'react'
import { EventType } from '../../../../../../constants'
import { useEventTracking } from '../../../../../../hooks'
import { FormMissingDataEventData } from '../../../../../../types'

interface Props {
  errors: Record<string, string>
}

const MissingData = ({ errors }: Props) => {
  const { track: trackEvent } = useEventTracking()

  const errorKeys = Object.keys(errors)

  useEffect(() => {
    const data: FormMissingDataEventData = {
      formType: 'initial',
      isInitialValid: false,
      missingData: errorKeys,
    }

    trackEvent(EventType.APPOINTMENT_FORM_MISSING_DATA, { data })
  }, [])

  return (
    <>
      <Typography variant="h2">The following data could not be resolved:</Typography>
      <ul>
        {errorKeys.map((key) => (
          <li key={key}>{errors[key]}</li>
        ))}
      </ul>
    </>
  )
}

export { MissingData }
